export default __webpack_public_path__ + "static/media/BlueBird.21ca6172.svg";